import { TimeoutError, HttpRequestError } from '../errors/request.js';
import { isNetworkError } from '../errors/utils/isNetworkError.js';
import { withTimeout } from './promise/withTimeout.js';

async function request({ url, body, timeout = 10000, fetchOptions, }) {
    const { headers, method, signal: signal_ } = fetchOptions ?? {};
    try {
        const response = await withTimeout(({ signal }) => {
            return fetch(url, {
                ...fetchOptions,
                method: method,
                headers: {
                    "Content-Type": "application/json",
                    ...headers,
                },
                body: JSON.stringify(body),
                signal: signal_ || (timeout > 0 ? signal : null),
            });
        }, {
            errorInstance: new TimeoutError({ body, url: url.toString() }),
            timeout,
            signal: true,
        });
        if (!response.ok) {
            throw new HttpRequestError({
                body,
                details: response.statusText,
                headers: response.headers,
                status: response.status,
                url: url.toString(),
            });
        }
        return response;
    }
    catch (err) {
        if (err instanceof HttpRequestError)
            throw err;
        if (err instanceof TimeoutError)
            throw err;
        if (isNetworkError(err)) {
            throw new HttpRequestError({
                body,
                cause: err,
                url: url.toString(),
            });
        }
        throw err;
    }
}

export { request };
//# sourceMappingURL=request.js.map
